import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { Loader2 } from "lucide-react";
import { AdminRouteLoader } from "@/components/admin/AdminRouteLoader";

interface ProtectedRouteProps {
  children: ReactNode;
  requireAdmin?: boolean;
  requireRep?: boolean;
  requireGuide?: boolean;
}

export function ProtectedRoute({ children, requireAdmin = false, requireRep = false, requireGuide = false }: ProtectedRouteProps) {
  const { user, isAdmin, isRep, isGuide, loading, mfaEnrolled, mfaLevel } = useAuth();

  if (loading) {
    if (requireAdmin) {
      return <AdminRouteLoader />;
    }
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  // Enforce MFA for all authenticated routes
  if (mfaEnrolled === false) {
    return <Navigate to="/mfa/enroll" replace />;
  }
  if (mfaEnrolled === true && mfaLevel === "aal1") {
    return <Navigate to="/mfa/verify" replace />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requireRep && !isRep && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requireGuide && !isGuide && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
